export enum FlowType {
  return = 'r',
  custom = 'c',
}

export enum ScheduleOffsetUnit {
  day = 'd',
  month = 'm',
}
